/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Google_Drive_OfflineInputs */

const en_google_drive_offline = /** @type {(inputs: Google_Drive_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect to the internet to use Google Drive.`)
};

const es_google_drive_offline = /** @type {(inputs: Google_Drive_OfflineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conéctate a internet para usar Google Drive.`)
};

/**
* | output |
* | --- |
* | "Connect to the internet to use Google Drive." |
*
* @param {Google_Drive_OfflineInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const google_drive_offline = /** @type {((inputs?: Google_Drive_OfflineInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Google_Drive_OfflineInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_google_drive_offline(inputs)
	return en_google_drive_offline(inputs)
});